import { Suspense, lazy } from 'react';
import { RouteObject } from 'react-router';
import SidebarLayout from 'src/layouts/SidebarLayout/SidebarLayout';
import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

const Home = Loader(lazy(() => import('src/content/pages/HomePage')));
const Caas = Loader(lazy(() => import('src/content/pages/CaasPage')));
const Users = Loader(lazy(() => import('src/content/pages/UsersPage')));
const BillingPage = Loader(lazy(() => import('src/content/pages/BillingPage')));
const OrphansPage = Loader(lazy(() => import('src/content/pages/OrphansPage')));
const PlayersPage = Loader(lazy(() => import('src/content/pages/PlayersPage')));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <SidebarLayout />,
    children: [
      // {
      //   path: '/',
      //   element: <Home />
      // },
      // {
      //   path: 'home',
      //   element: <Home />
      // },
      // {
      //   path: 'users',
      //   element: <Users />
      // },
      // {
      //   path: 'connect',
      //   element: <Caas />
      // },
      // {
      //   path: 'usage',
      //   element: <Home />
      // },
      // {
      //   path: 'clients',
      //   element: <Home />
      // },
      // {
      //   path: 'billing',
      //   element: <BillingPage />
      // },
      // {
      //   path: 'orphans',
      //   element: <OrphansPage />
      // },
      {
        path: '/',
        // path: 'players',
        element: <PlayersPage />
      }
    ]
  }
];

export default routes;
